function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L20 0L20 20L0 20L0 0Z",
  id: "mobile_small_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "mobile_small_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mobile_small_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "smartphone-(2)-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L20 0L20 20L0 20L0 0Z",
  id: "smartphone-(2)-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#mobile_small_mask_1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(4.0429688 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0.800781C0 0.359219 0.359219 0 0.800781 0C1.24234 0 1.60156 0.359219 1.60156 0.800781C1.60156 1.24234 1.2423 1.60156 0.800781 1.60156C0.359219 1.60156 0 1.24234 0 0.800781ZM0.585938 0.800781C0.585938 0.919258 0.682305 1.01562 0.800781 1.01562C0.919258 1.01562 1.01563 0.919258 1.01563 0.800781C1.01563 0.682305 0.919219 0.585937 0.800781 0.585937C0.682305 0.585937 0.585938 0.682305 0.585938 0.800781Z",
  transform: "translate(9.083984 1.2470703)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.6909 8.32667e-16C0.758516 8.32667e-16 0 0.758516 0 1.6909L0 3.14937C0 3.31117 0.131172 3.44234 0.292969 3.44234C0.454766 3.44234 0.585938 3.31117 0.585938 3.14937L0.585938 1.6909C0.585938 1.0816 1.0816 0.585938 1.6909 0.585938L10.2232 0.585938C10.8325 0.585938 11.3282 1.0816 11.3282 1.6909L11.3282 16.7383L0.585977 16.7383L0.585977 4.51656C0.585977 4.35477 0.454805 4.22359 0.293008 4.22359C0.131211 4.22359 3.9041e-05 4.35477 3.9041e-05 4.51656L3.9041e-05 17.0313L3.9041e-05 18.3091C3.9041e-05 19.2414 0.758554 20 1.69094 20L8.43953 20C8.60133 20 8.7325 19.8688 8.7325 19.707C8.7325 19.5452 8.60133 19.4141 8.43953 19.4141L1.6909 19.4141C1.08164 19.4141 0.585938 18.9184 0.585938 18.3091L0.585938 17.3242L11.3281 17.3242L11.3281 18.3091C11.3281 18.9184 10.8325 19.4141 10.2232 19.4141L9.80664 19.4141C9.64484 19.4141 9.51367 19.5452 9.51367 19.707C9.51367 19.8688 9.64484 20 9.80664 20L10.2232 20C11.1555 20 11.9141 19.2415 11.9141 18.3091L11.9141 17.0313L11.9141 1.6909C11.9141 0.758516 11.1555 0 10.2232 0L10.2232 8.32667e-16L1.6909 8.32667e-16Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0.292969C0 0.454766 0.131172 0.585938 0.292969 0.585938L2.05078 0.585938C2.21258 0.585938 2.34375 0.454766 2.34375 0.292969C2.34375 0.131172 2.21258 0 2.05078 0L0.292969 0C0.131172 0 0 0.131172 0 0.292969Z",
  transform: "translate(4.7851562 18.088379)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.32422 2.8125C2.59348 2.8125 2.8125 2.59348 2.8125 2.32422L2.8125 0.488281C2.8125 0.219023 2.59348 0 2.32422 0L0.488281 0C0.219023 0 0 0.219023 0 0.488281L0 2.32422C0 2.59344 0.219023 2.8125 0.488281 2.8125L2.32422 2.8125ZM2.22656 0.585938L2.22656 2.22656L0.585938 2.22656L0.585938 0.585938L2.22656 0.585938Z",
  transform: "translate(4.5507812 4.2836914)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.32422 2.8125C2.59348 2.8125 2.8125 2.59348 2.8125 2.32422L2.8125 0.488281C2.8125 0.219023 2.59348 0 2.32422 0L0.488281 0C0.219023 0 0 0.219023 0 0.488281L0 2.32422C0 2.59344 0.219062 2.8125 0.488281 2.8125L2.32422 2.8125ZM2.22656 0.585938L2.22656 2.22656L0.585938 2.22656L0.585938 0.585938L2.22656 0.585938Z",
  transform: "translate(1.2285156 4.2836914)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.32422 2.8125C2.59348 2.8125 2.8125 2.59348 2.8125 2.32422L2.8125 0.488281C2.8125 0.219023 2.59348 0 2.32422 0L0.488281 0C0.219023 0 0 0.219023 0 0.488281L0 2.32422C0 2.59344 0.219023 2.8125 0.488281 2.8125L2.32422 2.8125ZM2.22656 0.585938L2.22656 2.22656L0.585938 2.22656L0.585938 0.585938L2.22656 0.585938Z",
  transform: "translate(7.873047 4.2836914)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.488281 2.81252L2.32422 2.81252C2.59348 2.81252 2.8125 2.59349 2.8125 2.32423L2.8125 0.488284C2.8125 0.219025 2.59348 0 2.32422 0L0.488281 0C0.219023 0 0 0.219025 0 0.488284L0 2.32423C0 2.59349 0.219023 2.81252 0.488281 2.81252ZM2.22656 0.585941L2.22656 2.22657L0.585938 2.22657L0.585938 0.585941L2.22656 0.585941Z",
  transform: "translate(4.5507812 7.9379883)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.488281 2.81252L2.32422 2.81252C2.59348 2.81252 2.8125 2.59349 2.8125 2.32423L2.8125 0.488284C2.8125 0.219025 2.59348 0 2.32422 0L0.488281 0C0.219023 0 0 0.219025 0 0.488284L0 2.32423C0 2.59349 0.219023 2.81252 0.488281 2.81252ZM2.22656 0.585941L2.22656 2.22657L0.585938 2.22657L0.585938 0.585941L2.22656 0.585941Z",
  transform: "translate(1.2285156 7.9379883)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.488281 2.81252L2.32422 2.81252C2.59348 2.81252 2.8125 2.59349 2.8125 2.32423L2.8125 0.488284C2.8125 0.219025 2.59348 0 2.32422 0L0.488281 0C0.219023 0 0 0.219025 0 0.488284L0 2.32423C0 2.59349 0.219023 2.81252 0.488281 2.81252ZM2.22656 0.585941L2.22656 2.22657L0.585938 2.22657L0.585938 0.585941L2.22656 0.585941Z",
  transform: "translate(7.873047 7.9379883)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
})))));

var SvgMobile = function SvgMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobile.6750fdcf.svg";
export { ForwardRef as ReactComponent };